import { NgModule } from "@angular/core";
import {
    RouterModule,
    Routes,
    UrlMatchResult,
    UrlSegment,
} from "@angular/router";

import { ShopLocatorPageComponent } from "./components/shop-locator-page/shop-locator-page.component";
import { ShopLocatorPageResolver } from "./resolvers/shop-locator-page.resolver";

export const routes: Routes = [
    {
        /**
         * Because we manage the "/" in a non-native way (see {@link AppModule})
         * we have to manage the access to the /find-store/ page ourselves
         *
         * Indeed, Angular interprets the / as a new segment.
         */
        matcher: (url: UrlSegment[]): UrlMatchResult => {
            if (
                url.length === 1 &&
                url[0].path === "" &&
                Object.keys(url[0].parameters).length === 0
            ) {
                return {
                    consumed: [url[0]],
                };
            }
            return {
                consumed: [],
            };
        },
        component: ShopLocatorPageComponent,
        resolve: {
            mode: ShopLocatorPageResolver,
        },
    },
    {
        path: ":country/",
        component: ShopLocatorPageComponent,
        resolve: {
            mode: ShopLocatorPageResolver,
        },
    },
    {
        path: ":country/:city/",
        component: ShopLocatorPageComponent,
        resolve: {
            mode: ShopLocatorPageResolver,
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [ShopLocatorPageResolver],
})
export class ShopLocatorPageRoutingModule {}
